module.exports = __webpack_public_path__ + "static/img/cont32_07.bad597a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_07.jpg
// module id = KPcJ
// module chunks = 0